import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { insertFrame } from '../../actions/project/frame'
import CollectionProducts from '../../components/CollectionProducts'
import { assignIndex } from '../../utils'

const mapStateToProps = state => ({
  photos: dotProp
    .get(state, 'products.images', [])
    .map(assignIndex)
    .filter(frame => !frame.isSystem),
  isLoading: dotProp.get(state, 'products.isLoading', false),
  errMessage: dotProp.get(state, 'products.errMessage', ''),
})

const mapDispatchToProps = dispatch => ({
  insert: (width, height) => dispatch(insertFrame(width, height)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CollectionProducts)



// WEBPACK FOOTER //
// ./src/containers/CollectionProducts/index.js